import React from 'react';
import { Card, CardContent, Box, Typography, Avatar } from '@mui/material';
import { styled } from '@mui/material/styles';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ImageIcon from '@mui/icons-material/Image';

const ItemCardStyled = styled(Card)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    borderRadius: theme.spacing(2),
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)',
    cursor: 'pointer',
    transition: 'box-shadow 0.3s ease-in-out',
    '&:hover': {
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    },
}));

const ItemInfoStyled = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(1),
    '& .MuiAvatar-root': {
        width: 60,
        height: 60,
        marginRight: theme.spacing(2),
        borderRadius: theme.spacing(1),
    },
}));

const InfoContentStyled = styled(Box)(({ theme }) => ({
    flex: 1,
    '& .MuiTypography-subtitle1': {
        fontWeight: 600,
        marginBottom: theme.spacing(0.5),
    },
    '& .MuiTypography-body2': {
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(0.5),
    },
}));

const PriceStyled = styled(Typography)(({ theme }) => ({
    fontWeight: 600,
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
}));

const ItemCard = ({ imageSrc, title, description, price, onClick }) => {
    return (
        <ItemCardStyled onClick={onClick}>
            <CardContent>
                <ItemInfoStyled>
                    <Avatar variant="rounded" src={imageSrc} alt={title}>
                        <ImageIcon />
                    </Avatar>
                    <InfoContentStyled>
                        <Typography variant="subtitle1">
                            {title}
                        </Typography>
                        {description && (
                            <Typography
                                variant="body2"
                                sx={{
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    mb: 1
                                }}
                            >
                                {description}
                            </Typography>
                        )}
                        {price && (
                            <PriceStyled variant="body2">
                                {/* ${typeof price === 'number' ? price.toFixed(2) : price} */}
                                <ChevronRightIcon sx={{ ml: 'auto' }} color="action" />
                            </PriceStyled>
                        )}
                    </InfoContentStyled>
                </ItemInfoStyled>
            </CardContent>
        </ItemCardStyled>
    );
};

export default ItemCard;